import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable shortened OwF application form with soft credit check
 */
export const OWF_SOFT_CREDIT_CHECK_FLOW_240411 =
  'OWF_SOFT_CREDIT_CHECK_FLOW_240411' as SettingConst<
    'OWF_SOFT_CREDIT_CHECK_FLOW_240411',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
